import { createFileRoute } from '@tanstack/react-router';

// Приватная комната игрока поверх страницы комнаты: параметр читает родительский роут
export const Route = createFileRoute(
  '/club/$clubId_/tournament/$tournamentId_/referee/$roomNumber/private/$userId',
)({
  component: () => null,
});
